import { MenuDivider } from "@blueprintjs/core"
import axios from "axios"
import CustomDateRange from "components/Atoms/CustomDateRange"
import CustomTag from "components/Atoms/CustomTag"
import ActionMenu from "components/Organisms/ActionMenu"
import ActionMenuItem from "components/Organisms/ActionMenuItem"
import ReportDialog from "components/Templates/ReportDialog"
import Links from "constants/links"
import dayjs from "dayjs"
import React, { useState } from "react"

export function NumberBadge({ selectedArray, intent, count }) {
  return (
    <>
      <CustomTag minimal intent={intent} round>
        {selectedArray ? selectedArray.length : count ? count : 0}
      </CustomTag>
    </>
  )
}

export default function ProductionActions() {
  const [isDownloadOpen, toggleDownload] = useState(false)

  function handleClick(type) {
    switch (type) {
      case "download":
        toggleDownload(true)
        break
      default:
        break
    }
  }
  return (
    <>
      <ActionMenu onClick={handleClick}>
        <MenuDivider title="Report" icon="th" />
        <ActionMenuItem icon="download" text="Production" label=".xlsx" />
      </ActionMenu>

      <ReportDialog
        title="Production"
        isOpen={isDownloadOpen}
        onClose={e => toggleDownload(false)}
        onClick={async ({ dateRange }) => {
          const response = await axios.post(
            Links.PRODUCTION_REPORT,
            {
              from_date: dateRange?.[0],
              till_date: dateRange?.[1],
            },
            {
              responseType: "blob",
            }
          )
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement("a")
          link.href = url
          link.setAttribute(
            "download",
            `Production report for ${dayjs(dateRange?.[0]).format(
              "DD-MM-YYYY"
            )} to ${dayjs(dateRange?.[1]).format("DD-MM-YYYY")}.xlsx`
          )
          document.body.appendChild(link)
          link.click()
          toggleDownload(false)
        }}
      >
        <CustomDateRange
          fill
          fixed
          big={false}
          shortcuts={true}
          path="dateRange"
          label="Date Range"
          valueAs="DDMMYYYY"
        />
      </ReportDialog>
    </>
  )
}
